import { render, staticRenderFns } from "./ProcedimentoComplementarAP.vue?vue&type=template&id=3e670387&"
import script from "./ProcedimentoComplementarAP.vue?vue&type=script&lang=js&"
export * from "./ProcedimentoComplementarAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports